var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoaderContent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 976,
    height: 1100,
    viewBox: "0 0 976 1100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 572,
    height: 40,
    rx: 4,
    fill: "#EFF2FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 50,
    width: 336,
    height: 40,
    rx: 4,
    fill: "#EFF2FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 111,
    width: 572,
    height: 22,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 188,
    width: 843,
    height: 48,
    rx: 8,
    fill: "#F6F8FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 855,
    y: 188,
    width: 121,
    height: 48,
    rx: 8,
    fill: "#EFF2FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 284,
    width: 304,
    height: 392,
    rx: 12,
    fill: "#F6F8FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 92,
    y: 334,
    width: 120,
    height: 48,
    rx: 8,
    fill: "#E7ECFE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 57,
    y: 412,
    width: 190,
    height: 21,
    rx: 4,
    fill: "#E7ECFE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 82,
    y: 445,
    width: 140,
    height: 19,
    rx: 4,
    fill: "#E7ECFE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 20,
    y: 608,
    width: 152,
    height: 48,
    rx: 10,
    fill: "#E7ECFE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 180,
    y: 608,
    width: 104,
    height: 48,
    rx: 10,
    fill: "#E7ECFE"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 284,
    width: 304,
    height: 392,
    rx: 12,
    fill: "#F6F8FF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 428,
    y: 334,
    width: 120,
    height: 48,
    rx: 8,
    fill: "#E7ECFE"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 393,
    y: 412,
    width: 190,
    height: 21,
    rx: 4,
    fill: "#E7ECFE"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 418,
    y: 445,
    width: 140,
    height: 19,
    rx: 4,
    fill: "#E7ECFE"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 356,
    y: 608,
    width: 152,
    height: 48,
    rx: 10,
    fill: "#E7ECFE"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 516,
    y: 608,
    width: 104,
    height: 48,
    rx: 10,
    fill: "#E7ECFE"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 672,
    y: 284,
    width: 304,
    height: 392,
    rx: 12,
    fill: "#F6F8FF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 764,
    y: 334,
    width: 120,
    height: 48,
    rx: 8,
    fill: "#E7ECFE"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 729,
    y: 412,
    width: 190,
    height: 21,
    rx: 4,
    fill: "#E7ECFE"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 754,
    y: 445,
    width: 140,
    height: 19,
    rx: 4,
    fill: "#E7ECFE"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 692,
    y: 608,
    width: 152,
    height: 48,
    rx: 10,
    fill: "#E7ECFE"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 852,
    y: 608,
    width: 104,
    height: 48,
    rx: 10,
    fill: "#E7ECFE"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    y: 708,
    width: 304,
    height: 392,
    rx: 12,
    fill: "#F6F8FF"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 92,
    y: 758,
    width: 120,
    height: 48,
    rx: 8,
    fill: "#E7ECFE"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 57,
    y: 836,
    width: 190,
    height: 21,
    rx: 4,
    fill: "#E7ECFE"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 82,
    y: 869,
    width: 140,
    height: 19,
    rx: 4,
    fill: "#E7ECFE"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 20,
    y: 1032,
    width: 152,
    height: 48,
    rx: 10,
    fill: "#E7ECFE"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 180,
    y: 1032,
    width: 104,
    height: 48,
    rx: 10,
    fill: "#E7ECFE"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 708,
    width: 304,
    height: 392,
    rx: 12,
    fill: "#F6F8FF"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 428,
    y: 758,
    width: 120,
    height: 48,
    rx: 8,
    fill: "#E7ECFE"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 393,
    y: 836,
    width: 190,
    height: 21,
    rx: 4,
    fill: "#E7ECFE"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 418,
    y: 869,
    width: 140,
    height: 19,
    rx: 4,
    fill: "#E7ECFE"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 356,
    y: 1032,
    width: 152,
    height: 48,
    rx: 10,
    fill: "#E7ECFE"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 516,
    y: 1032,
    width: 104,
    height: 48,
    rx: 10,
    fill: "#E7ECFE"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 672,
    y: 708,
    width: 304,
    height: 392,
    rx: 12,
    fill: "#F6F8FF"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 764,
    y: 758,
    width: 120,
    height: 48,
    rx: 8,
    fill: "#E7ECFE"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 729,
    y: 836,
    width: 190,
    height: 21,
    rx: 4,
    fill: "#E7ECFE"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 754,
    y: 869,
    width: 140,
    height: 19,
    rx: 4,
    fill: "#E7ECFE"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 692,
    y: 1032,
    width: 152,
    height: 48,
    rx: 10,
    fill: "#E7ECFE"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 852,
    y: 1032,
    width: 104,
    height: 48,
    rx: 10,
    fill: "#E7ECFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderContent);
export default __webpack_public_path__ + "static/media/loader-content.19d3cb3a190f937d7e0371b817899789.svg";
export { ForwardRef as ReactComponent };